<template>
  <main class="relative flex flex-col items-center 3xl:h-full 3xl:justify-center">
    <div v-if="errors.length" class="errors-banner px-10 py-5 mt-5 rounded-md">
      <ul >
        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
      </ul>
    </div>
    <div class="wrapper p-5 w-full mb-20 sm:w-8/12 sm:flex sm:flex-col sm:items-center md:w-10/12 lg:w-8/12 xl:w-7/12 2xl:w-6/12 3xl:flex-row 3xl:items-end 3xl:w-full 3xl:self-center">
      <section class="implements-section flex flex-col items-center mb-10 sm:w-full md:mt-20 3xl:mt-0 3xl:mb-0">
        <p class="font-bold mb-4 text-center">1. {{ this.$translations[this.$root.language].selectImplement }}</p>
        <div class="section-inner implements w-full md:flex md:flex-row 3xl:h-full">
          <div class="spreader flex justify-center items-center z-10 relative rounded-t-md 3xl:rounded-t-none 3xl:rounded-l-md" @click="populateImplementType('spreader')">
            <p class="implement-text font-bold z-30 3xl:text-xl">
              {{ this.$translations[this.$root.language].spreader }}
            </p>
            <div class="darken-layer h-full w-full z-20 absolute rounded-t-sm 3xl:rounded-t-none 3xl:rounded-l-md"></div>
          </div>
          <div class="sprayer flex justify-center items-center z-10 relative" @click="populateImplementType('sprayer')">
            <p class="implement-text font-bold z-30 3xl:text-xl">
              {{ this.$translations[this.$root.language].sprayer }}
            </p>
            <div class="darken-layer h-full w-full z-20 absolute"></div>
          </div>
          <div class="seeder flex justify-center items-center z-10 relative rounded-b-md 3xl:rounded-b-none" @click="populateImplementType('seeder')">
            <p class="implement-text font-bold z-30 3xl:text-xl">
              {{ this.$translations[this.$root.language].seeder }}
            </p>
            <div class="darken-layer h-full w-full z-20 absolute rounded-b-md 3xl:rounded-b-none"></div>
          </div>
        </div>
      </section>
      <section id="field-scroll" class="field-shapes-section flex flex-col items-center mb-10 sm:w-full 3xl:mb-0 3xl:w-4/12 ">
        <p class="font-bold mb-4 text-center">
          2. {{ this.$translations[this.$root.language].selectFieldSize }}
        </p>
        <div class="section-inner field-size-wrapper flex flex-wrap items-center justify-center px-5 py-5 w-full rounded-md 3xl:rounded-none 3xl:flex-col 3xl:h-full">
          <div class="regularField field-size field-1 w-full mb-8 sm:max-w-xs md:w-5/12 md:mx-3 3xl:w-full" @click="populateFieldSize('regularField')"></div>
          <div class="poligonalField field-size field-2 w-full mb-8 sm:max-w-xs md:w-5/12 md:mx-3 3xl:w-full" src="@/assets/images/field-sizes/field_2.svg" @click="populateFieldSize('poligonalField')"></div>
          <div class="slightlyIrregularField field-size field-3 w-full mb-8 sm:max-w-xs md:w-5/12 md:mx-3 md:mb-0 3xl:w-full 3xl:mb-8" src="@/assets/images/field-sizes/field_3.svg" @click="populateFieldSize('slightlyIrregularField')"></div>
          <div class="irregularField field-size field-4 w-full sm:max-w-xs md:w-5/12 md:mx-3 3xl:w-full" src="@/assets/images/field-sizes/field_4.svg" @click="populateFieldSize('irregularField')"></div>
        </div>
      </section>
      <section id="form-scroll" class="sm:w-full 3xl:items-stretch mb-20 3xl:mb-0">
        <p class="font-bold mb-4 text-center">3. {{ this.$translations[this.$root.language].inputYourDetails }}</p>
        <form class="relative section-inner flex flex-col bg-green p-5 rounded-md 3xl:flex-row 3xl:flex-wrap 3xl:rounded-l-none 3xl-rounded-r-md" action="./submit-form" method="POST" @submit.prevent="processForm()">
          <input id="implement-input" type="hidden" name="implementType" v-model="implementType" required />
          <input id="field-size-input" type="hidden" name="fieldSize" v-model="fieldSize" required />
          <h1 class="font-bold w-full text-center mb-4 text-3xl">Calculator</h1>
          <fieldset class="md:flex md:justify-between md:flex-row md:flex-wrap 3xl:flex-col 3xl:justify-start 3xl:w-4/12">
            <legend class="font-bold mb-4">{{ this.$translations[this.$root.language].yourFarmToday }}</legend>
            <p class="flex flex-col mb-2 md:w-6/12 md:pr-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="totalFarmSize">{{ this.$translations[this.$root.language].totalFarmSize }}</label>
              <input class="" name="totalFarmSize" :placeholder="this.$translations[this.$root.language].farmSize" type="number" v-model="totalFarmSize" required @change="saveToSessionStorage('totalFarmSize')" />
            </p>
            <p class="flex flex-col mb-2 md:w-6/12 md:pl-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="numberOfFields">{{ this.$translations[this.$root.language].numberOfFields }}</label>
              <input class="" name="numberOfFields" :placeholder="this.$translations[this.$root.language].fields" type="number" v-model="numberOfFields" required @change="saveToSessionStorage('numberOfFields')" />
            </p>
            <p class="flex flex-col mb-2 md:w-6/12 md:pr-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="averageFieldSize">{{ this.$translations[this.$root.language].averageFieldSize }}</label>
              <input class="" name="averageFieldSize" placeholder="" v-model="averageFieldSize" disabled @change="saveToSessionStorage('averageFieldSize')">
            </p>
            <p class="flex flex-col mb-2 md:w-6/12 md:pl-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="amountOfProduct">
                {{ this.amountOfProductLabel.length > 0 ? this.amountOfProductLabel : this.$translations[this.$root.language].amountOfProductLabelSpreader }}
              </label>
              <input class="" name="amountOfProduct"
              :placeholder="this.amountOfProductPlaceholder.length > 0 ? this.amountOfProductPlaceholder : this.$translations[this.$root.language].amountOfProductPlaceholderSpreader"
              type="number" v-model="amountOfProduct" required @change="saveToSessionStorage('amountOfProduct')">
            </p>
            <p class="flex flex-col mb-2 md:w-6/12 md:pr-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="costOfProduct">
                {{ this.costOfProductLabel.length > 0 ? this.costOfProductLabel : this.$translations[this.$root.language].costOfProductLabelSpreader }}
              </label>
              <input class="" name="costOfProduct"
              :placeholder="this.costOfProductPlaceholder.length > 0 ? this.costOfProductPlaceholder : this.$translations[this.$root.language].costOfProductPlaceholderSpreader"
              v-model="costOfProduct" required @change="saveToSessionStorage('costOfProduct')">
            </p>
          </fieldset>
          <fieldset class="md:flex md:justify-between md:flex-row md:flex-wrap 3xl:flex-col 3xl:content-center 3xl:w-4/12 3xl:justify-start">
            <legend class="font-bold mb-4 margin-left-9">{{ this.$translations[this.$root.language].currentSituation }}</legend>
            <p class="flex flex-col mb-2 md:w-6/12 md:pr-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="workingWidthCurrent">{{ this.$translations[this.$root.language].workingWidth }}</label>
              <input class="" name="workingWidthCurrent" :placeholder="this.$translations[this.$root.language].workingWidth" type="number" v-model="workingWidthCurrent" required @change="saveToSessionStorage('workingWidthCurrent')">
            </p>
            <p class="flex flex-col mb-2 md:w-6/12 md:pl-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="numberOfSectionsCurrent">{{ this.$translations[this.$root.language].numberOfSections }}</label>
              <input class="" name="numberOfSectionsCurrent" :placeholder="this.$translations[this.$root.language].sections" type="number" v-model="numberOfSectionsCurrent" required @change="saveToSessionStorage('numberOfSectionsCurrent')">
            </p>
            <p class="flex flex-col mb-2 md:w-6/12 3xl:w-11/12 3xl:p-0">
              <label class="" for="controlTypeCurrent">{{ this.$translations[this.$root.language].selectControlType }}</label>
              <select class="" name="controlTypeCurrent" v-model="controlTypeCurrent" required @change="saveToSessionStorage('controlTypeCurrent')">
                <option class="grey-text" value="" disabled selected>Control type</option>
                <option class="" value="manual" selected>{{ this.$translations[this.$root.language].manual }}</option>
                <option class="" value="taskcontroller" selected>{{ this.$translations[this.$root.language].taskControl }}</option>
              </select>
            </p>
            <p v-if="implementType === 'spreader'" class="flex flex-col mb-2 md:w-6/12 md:px-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="spreaderType">{{ this.$translations[this.$root.language].spreaderType }}</label>
              <select class="" name="spreaderType" v-model="spreaderType" required @change="saveToSessionStorage('spreaderType')">
                <option class="grey-text" value="" disabled selected>Spreader Type</option>
                <option class="" value="0.05" selected>{{ this.$translations[this.$root.language].conventional }}</option>
                <option class="" value="0" selected>{{ this.$translations[this.$root.language].weighingCell }}</option>
              </select>
            </p>
          </fieldset>
          <div class="calculator-separator rounded-b-md 3xl:rounded-r-md 3xl:rounded-b-none"></div>
          <fieldset class="z-10 md:flex md:justify-between md:flex-row md:flex-wrap 3xl:flex-col 3xl:content-end 3xl:w-4/12 3xl:justify-start">
            <legend class="font-bold mb-4 margin-left-19">{{ this.$translations[this.$root.language].futureSituation }}</legend>
            <p class="flex flex-col mb-2 md:w-6/12 md:pr-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="workingWidthFuture">{{ this.$translations[this.$root.language].workingWidth }}</label>
              <input class="" name="workingWidthFuture" placeholder="Working Width" type="number" v-model="workingWidthFuture" required @change="saveToSessionStorage('workingWidthFuture')">
            </p>
            <p class="flex flex-col mb-2 md:w-6/12 md:pl-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="numberOfSectionsFuture">{{ this.$translations[this.$root.language].numberOfSections }}</label>
              <input class="" name="numberOfSectionsFuture" :placeholder="this.$translations[this.$root.language].sections" type="number" v-model="numberOfSectionsFuture" required @change="saveToSessionStorage('numberOfSectionsFuture')">
            </p>
            <p class="flex flex-col mb-2 md:w-6/12 md:pr-2 3xl:w-11/12 3xl:p-0">
              <label class="" for="controlTypeFuture">{{ this.$translations[this.$root.language].selectControlType }}</label>
              <select class="" name="controlTypeFuture" placeholder="Control type" v-model="controlTypeFuture" required @change="saveToSessionStorage('controlTypeFuture')">
                <option class="grey-text" value="" disabled selected>Control type</option>
                <option class="" value="manual" selected>{{ this.$translations[this.$root.language].manual }}</option>
                <option class="" value="geocontrol" selected>GEOCONTROL</option>
                <option v-if="implementType === 'spreader'" class="" value="geocontrolandgeospread" selected>GEOCONTROL & GEOSPREAD</option>
              </select>
            </p>
          </fieldset>
          <div class="z-10 flex justify-end w-full submit-wrapper">
            <button id="submit-button" class="p-3 font-bold rounded-sm sm:self-end" type="submit">
              <span>
                {{ this.$translations[this.$root.language].saveDetails }}
              </span>
              <img id="spinner" class="hidden" style="width:40px; animation: spin 2s linear infinite;" :src="this.$root.getImgUrl('/images/spinner.svg')">
            </button>
          </div>
        </form>
      </section>
    </div>
    <div class="back-button-wrapper px-5 mb-4 w-auto 3xl:px-5">
      <router-link class="hover-green-bg back-button rounded-sm self-start" to="/">{{ this.$translations[this.$root.language].back }}</router-link>
    </div>
  </main>
</template>

<style lang="scss" scoped>
  form {
    background-color: rgba(0,0,0,.5);
  }
  input, select {
    border-radius: 3px;
    height: 40px;
    padding-left: 5px;
    color: #333333;
  }
  label {
    font-weight: medium;
  }
  form button {
    background-color: #66CC33;
    max-width: 175px;
  }
  .submit-wrapper a {
    height: 50px;
    background-color: #66CC33;
    &:hover {
      background-color: #4DB31A;
    }
  }
  .implements-section {
    max-width: 700px
  }
  .implements {
    div {
      height: 200px;
      width: 100%;
      cursor: pointer;
      transition-property: all;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration: 150ms;
      &:hover .darken-layer{
        opacity: 0.4;

      }
      &:hover {
        color: #66CC33;
      }
    }
    #selected-implement {
      color: #66CC33;
      .darken-layer {
        opacity: 0.4 !important;
      }
    }
  }
  .spreader {
    background: center/cover no-repeat url('../assets/images/spreader.png');
  }
  .sprayer {
    background: center/cover no-repeat url('../assets/images/sprayer.png');
  }
  .seeder {
    background: center/cover no-repeat url('../assets/images/seeder.png');
  }
  .field-size-wrapper {
    background-color: rgba(0,0,0,0.5);
    div {
      cursor: pointer;
    }
  }
  .field-1 {
    background: center/contain no-repeat url('../assets/images/field-sizes/field_1.svg');
    &:hover {
      background: center/contain no-repeat url('../assets/images/field-sizes/field_1_highlighted.svg');
    }
  }
  .field-2 {
    background: center/contain no-repeat url('../assets/images/field-sizes/field_2.svg');
    &:hover {
      background: center/contain no-repeat url('../assets/images/field-sizes/field_2_highlighted.svg');
    }
  }
  .field-3 {
    background: center/contain no-repeat url('../assets/images/field-sizes/field_3.svg');
    &:hover {
      background: center/contain no-repeat url('../assets/images/field-sizes/field_3_highlighted.svg');
    }
  }
  .field-4 {
    background: center/contain no-repeat url('../assets/images/field-sizes/field_4.svg');
    &:hover {
      background: center/contain no-repeat url('../assets/images/field-sizes/field_4_highlighted.svg');
    }
  }
  #highlighted.field-1 {
    background: center/contain no-repeat url('../assets/images/field-sizes/field_1_highlighted.svg');
  }
  #highlighted.field-2 {
    background: center/contain no-repeat url('../assets/images/field-sizes/field_2_highlighted.svg');
  }
  #highlighted.field-3 {
    background: center/contain no-repeat url('../assets/images/field-sizes/field_3_highlighted.svg');
  }
  #highlighted.field-4 {
    background: center/contain no-repeat url('../assets/images/field-sizes/field_4_highlighted.svg');
  }
  .calculated-input {
    background-color: #66CC33;
    color: white;
    &::placeholder {
      color: white;
    }
  }
  .separator {
    height: 64px;
  }
  .implement-text {
    max-width: 80%;
    text-align: center;
  }
  .errors-banner {
    position: relative;
    display: block;
    width: auto;
    background-color: #9C1A1A;
    & ul {
      list-style-type: disc;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  input:disabled {
    background-color: #a1a1a1;
  }
  .calculator-separator {
    height: 324px;
    background-color: #990;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 0;
    width: 100%;
  }
  @media(min-width: 375px) {
    .field-1, .field-2, .field-3, .field-4 {
      height: 140px;
    }
  }
  @media(min-width: 768px) {
    .implements div {
      height: 400px;
    }
    .calculator-separator {
      height: 253px;
    }
  }
  @media(min-width: 1920px) {
    .field-shapes-section {
      max-width: 250px;
    }
    .wrapper {
      max-width: 1850px;
    }
    .implements div {
      height: 100%;
    }
    .margin-left-9 {
      margin-left: 9px;
    }
    .margin-left-19 {
      margin-left: 19px;
    }
    .field-size {
      height: 20%;
    }
    .section-inner {
      height: 600px;
    }
    form button {
      max-width: unset;
    }
  .calculator-separator {
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
    width: 287px;
    }
  }
</style>

<script>
export default {
  data: function () {
    return {
      totalFarmSize: '',
      numberOfFields: '',
      averageFieldSize: '',
      workingWidthCurrent: '',
      numberOfSectionsCurrent: '',
      controlTypeCurrent: '',
      costOfProduct: '',
      workingWidthFuture: '',
      numberOfSectionsFuture: '',
      controlTypeFuture: '',
      implementType: '',
      fieldSize: '',
      amountOfProduct: '',
      baseFieldConstant: '',
      amountOfProductLabel: '',
      amountOfProductPlaceholder: '',
      costOfProductLabel: '',
      costOfProductPlaceholder: '',
      spreaderType: '',
      implementTypeError: false,
      fieldSizeTypeError: false,
      errors: {}
    }
  },
  mounted: function () {
    const keysArray = ['totalFarmSize', 'numberOfFields', 'workingWidthCurrent', 'numberOfSectionsCurrent', 'controlTypeCurrent',
    'costOfProduct', 'workingWidthFuture', 'numberOfSectionsFuture', 'controlTypeFuture', 'implementType', 'fieldSize', 'amountOfProduct', 'spreaderType']
    // If our sessionStorage variables exist, use those values.
    keysArray.forEach(key => {
      if (sessionStorage.getItem(key)) {
        const inputValue = sessionStorage.getItem(key)
        this[key] = inputValue

        if (key === 'implementType') {
          document.getElementsByClassName(inputValue)[0].id = 'selected-implement'
        }
        if (key === 'fieldSize') {
          document.getElementsByClassName(inputValue)[0].id = 'highlighted'
        }
      } else {
        // If it doesn't exist in session storage then grab value from the cookie.
        if (document.cookie.split(';').some((item) => item.trim().startsWith(key + '='))) {
          const cookieValue = document.cookie
          .split('; ')
          .find(row => row.startsWith(key + '='))
          .split('=')[1]

          this[key] = cookieValue

          if (key === 'implementType') {
            document.getElementsByClassName(cookieValue)[0].id = 'selected-implement'
          }
          if (key === 'fieldSize') {
            document.getElementsByClassName(cookieValue)[0].id = 'highlighted'
          }
        }
      }
    })
  },
  computed: {
    averageFieldSizeComputed: function () {
      return (this.totalFarmSize / this.numberOfFields).toFixed(2)
    },
    oldSituationComputed: function () {
      return ((this.averageFieldSize) * ((this.workingWidthCurrent / this.numberOfSectionsCurrent) * 0.3) * (((5 / this.averageFieldSize) ** 2) * this.baseFieldConstant))
    },
    newSituationComputed: function () {
      return ((this.averageFieldSize) * ((this.workingWidthFuture / this.numberOfSectionsFuture) * 0.3) * (((5 / this.averageFieldSize) ** 2) * this.baseFieldConstant))
    },
    fieldSizeTypeCalculated: function () {
      return (this.averageFieldSize)
    },
    newFieldSizeConstantCalculated: function () {
      return (this.averageFieldSize)
    },
    controlTypeCalculated: function () {
      return this.controlTypeCurrent
    }
  },
  watch: {
    averageFieldSizeComputed: function () {
      this.averageFieldSize = this.averageFieldSizeComputed
    },
    implementType: function (val) {
      var implementToUpper = val.charAt(0).toUpperCase() + val.slice(1)
      // Build a string to pull out the data from our JSON.
      this.amountOfProductLabel = this.$translations[this.$root.language]['amountOfProductLabel'.concat(implementToUpper)]
      this.amountOfProductPlaceholder = this.$translations[this.$root.language]['amountOfProductPlaceholder'.concat(implementToUpper)]
      this.costOfProductLabel = this.$translations[this.$root.language]['costOfProductLabel'.concat(implementToUpper)]
      this.costOfProductPlaceholder = this.$translations[this.$root.language]['costOfProductPlaceholder'.concat(implementToUpper)]
    }
  },
  methods: {
    saveToSessionStorage (key) {
      sessionStorage.setItem(key, event.target.value)
    },
    populateFieldSize (fieldSize) {
      if (document.getElementById('highlighted')) {
        document.getElementById('highlighted').id = ''
      }
      event.target.id = 'highlighted'
      this.fieldSize = fieldSize
      sessionStorage.setItem('fieldSize', fieldSize)

      document.getElementById('form-scroll').scrollIntoView()
    },
    populateImplementType (implement) {
      if (document.getElementById('selected-implement')) {
        document.getElementById('selected-implement').id = ''
      }

      event.target.parentElement.id = ('selected-implement')
      this.implementType = implement
      sessionStorage.setItem('implementType', implement)

      document.getElementById('field-scroll').scrollIntoView()
    },
    processForm () {
      const submitButton = document.getElementById('submit-button')
      const form = document.querySelector('form')
      const data = {}
      var formElements = Array.from(form)
      // Removing the last empty value of the button which is passed due to constructing an array from the form.
      formElements.map(input => (data[input.name] = input.value))
      data.websiteCookies = this.$root.websiteCookies

      // Reset our errors array
      this.errors = []

      // Check our data is valid to send as JSON
      try {
        JSON.stringify(data)
      } catch (e) {
        this.errors.push('Your submission failed to send, please try again.')
      }

      // Remove empty data caused by button
      delete data['']

      // Check the user has selected a implement and field size type.
      if (this.implementType.length < 1) {
        this.errors.push(this.$translations[this.$root.language].selectImplementType)
      }
      if (this.fieldSize.length < 1) {
        this.errors.push(this.$translations[this.$root.language].selectFieldShape)
      }

      // Prevent form from submitting if either not selected.
      if (this.errors.length > 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
        return
      }

      // Populate our variable associated to the field size with a float value to use for other calculations. 
      if (this.fieldSize === 'regularField') {
        this.baseFieldConstant = 0.001
      } else if (this.fieldSize === 'poligonalField') {
        this.baseFieldConstant = 0.002
      } else if (this.fieldSize === 'slightlyIrregularField') {
        this.baseFieldConstant = 0.003
      } else {
        this.baseFieldConstant = 0.005
      }

      // Calculate our savings
      var savings = this.oldSituationComputed - this.newSituationComputed
      var calculatedFieldConstant = 0
      // Calculate our new constant based on average field size and using the
      // field constant value.
      if (this.averageFieldSize < 5) {
        // Return new constant by using a figure (1 through 4) of whichever constant from our object
        // calculatedFieldConstant refers to the "Standard Savings"
        calculatedFieldConstant = this.$fieldConstant.extraSmall[this.fieldSize]
      } else if (this.averageFieldSize <= 20) {
        calculatedFieldConstant = this.$fieldConstant.small[this.fieldSize]
      } else if (this.averageFieldSize <= 50) {
        calculatedFieldConstant = this.$fieldConstant.medium[this.fieldSize]
      } else if (this.averageFieldSize <= 200) {
        calculatedFieldConstant = this.$fieldConstant.large[this.fieldSize]
      } else {
        calculatedFieldConstant = this.$fieldConstant.extraLarge[this.fieldSize]
      }

      // Figure out our standars savings addition.
      var standardSavingsAddition = 0
      if (this.controlTypeCurrent === this.controlTypeFuture) {
        standardSavingsAddition = 0
      } else if (this.controlTypeCurrent === 'manual' && this.controlTypeFuture.includes('geo')) {
        standardSavingsAddition = 1
      } else if (this.controlTypeCurrent === 'taskcontroller' && this.controlTypeFuture === 'manual') {
        standardSavingsAddition = -1
      } else {
        standardSavingsAddition = 0
      }

      // Instead of using this.controlTypeFuture we need a calculated variable which uses
      // the old control type + the new control type
      // this.controlTypeFuture needs to be a calculated variable taking into account both control selections (see sheet)
      var totalSavings = 0
      if (this.implementType !== 'spreader') {
        totalSavings = savings + (calculatedFieldConstant * standardSavingsAddition)
      } else {
        var differenceControlSpread = 0
        var differenceControlSpreadFigure = 0
        var standardCalculation = 0

        if (this.baseFieldConstant > 0.0011 && this.controlTypeFuture === 'geocontrolandgeospread') {
          differenceControlSpread = ((this.oldSituationComputed - this.newSituationComputed) + parseFloat(calculatedFieldConstant)) * 0.5
        } else {
          differenceControlSpread = 0
        }

        differenceControlSpreadFigure = parseFloat(this.averageFieldSize * ((5 / this.averageFieldSize) * (5 / this.averageFieldSize) * (this.workingWidthFuture / this.numberOfSectionsCurrent) * 0.3) * this.baseFieldConstant)

        // If they're selecting a 'better' control for their new machine we add the calculatedFieldConstant otherwise we subtract it from the standard calculation.
        if (this.controlTypeCurrent === 'manual' && this.controlTypeFuture.includes('geo')) {
          standardCalculation = (parseFloat(this.oldSituationComputed) - differenceControlSpreadFigure) + parseFloat(calculatedFieldConstant)
        } else if (this.controlTypeCurrent === 'taskcontroller' && this.controlTypeFuture === 'manual') {
          standardCalculation = (parseFloat(this.oldSituationComputed) - differenceControlSpreadFigure) - parseFloat(calculatedFieldConstant)
        } else if (this.controlTypeCurrent === 'taskcontroller' && this.controlTypeFuture.includes('geo')) {
          standardCalculation = (parseFloat(this.oldSituationComputed) - differenceControlSpreadFigure) + parseFloat(calculatedFieldConstant) + -parseFloat(calculatedFieldConstant)
        }

        totalSavings = differenceControlSpread + standardCalculation + parseFloat(this.spreaderType)
      }

      var currentApplicationAmount = this.totalFarmSize * this.amountOfProduct
      var currentApplicationCost = currentApplicationAmount * this.costOfProduct
      var savingsAmount = (currentApplicationAmount * totalSavings)
      var savingsCost = (currentApplicationCost * totalSavings)
      var newApplicationCost = (currentApplicationCost - savingsCost)
      var totalSavingsPercentage = (totalSavings * 100).toFixed(2)

      this.$root.savingsPercentageGlobal = totalSavingsPercentage
      this.$root.savingsCostGlobal = new Intl.NumberFormat().format(savingsCost.toFixed(0))
      this.$root.savingsAmountGlobal = new Intl.NumberFormat().format(savingsAmount.toFixed(0))
      this.$root.newApplicationCostGlobal = new Intl.NumberFormat().format(newApplicationCost.toFixed(0))
      this.$root.implementGlobal = this.implementType

      // Set fieldSize to decipher which adverts to display.
      if (this.averageFieldSize <= 50) {
        this.$root.fieldSizeGlobal = 'fieldSizeSmall'
      } else if (this.averageFieldSize <= 100) {
        this.$root.fieldSizeGlobal = 'fieldSizeMedium'
      } else {
        this.$root.fieldSizeGlobal = 'fieldSizeLarge'
      }

      // Set session variables to retain calculated output for savings page.
      sessionStorage.setItem('savingsPercentageGlobal', this.$root.savingsPercentageGlobal)
      sessionStorage.setItem('savingsCostGlobal', this.$root.savingsCostGlobal)
      sessionStorage.setItem('savingsAmountGlobal', this.$root.savingsAmountGlobal)
      sessionStorage.setItem('newApplicationCostGlobal', this.$root.newApplicationCostGlobal)
      sessionStorage.setItem('implementGlobal', this.$root.implementGlobal)
      sessionStorage.setItem('fieldSizeGlobal', this.$root.fieldSizeGlobal)

      // Disable submit button to prevent multiple submissions, add spinner.
      submitButton.disabled = true
      submitButton.firstChild.classList.add('hidden')
      document.getElementById('spinner').classList.remove('hidden')

      // Construct an HTTP request
      var xhr = new XMLHttpRequest()
      xhr.open(form.method, form.action, true)
      xhr.setRequestHeader('Accept', 'application/json; charset=UTF-8')
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')

      // Send the collected data as JSON
      xhr.send(JSON.stringify(data))

      // Callback function
      xhr.onloadend = response => {
        if (response.target.status === 200) {
          this.$router.push('savings')
        }
        if (response.target.status !== 200) {
          // The form submission failed
          this.errors = true
          document.getElementById('spinner').classList.add('hidden')
          submitButton.firstElementChild.classList.remove('hidden')
          submitButton.disabled = false
        }
      }
    }
  }
}
</script>